import '~/js/modules/stickyNav';
import SpaTeens from '~/js/components/spa-teens/SpaTeens';

// Variable Declaration
const teens = document.getElementById('spa-teens');

// Render react component
ReactDOM.render(<SpaTeens />, teens);
